// @lumi/app-kit shared i18n vocabulary (ADR 0026 §7) — locale pt.
// Byte-identical common.*/errors.* used across >=3 apps + owned by app-kit components.
// Apps merge appKitMessages under their own catalog; the no-shadow check forbids an
// app from redefining these keys. Generated from the per-app catalogs.
export default {
  // The sidebar's account menu + history buttons (suite design foundation, spec §4):
  // byte-identical across every chrome, so owned here rather than by nine app catalogs.
  accountMenu: {
    profile: 'O meu perfil',
    settings: 'Definições',
    theme: 'Aspeto',
    themeLight: 'Claro',
    themeDark: 'Escuro',
    support: 'Suporte',
    back: 'Anterior',
    forward: 'Seguinte',
    collapseSidebar: 'Recolher a barra lateral',
    expandSidebar: 'Expandir a barra lateral',
    // The account row of a phone-only account (issue 698): no name, no address.
    signedIn: 'Sessão iniciada',
  },
  // A sidebar entry another of the viewer's own roles opens (#1028): the
  // greyed entry's hint, its switch dialog, and the role list joiner.
  roleLock: {
    hint: 'Apenas como {roles}. Mudar de função: canto inferior esquerdo, conta → Função.',
    body: 'Esta área está disponível como {roles}. Função ativa: {active}.',
    action: 'Abrir como {role}',
    where: 'É possível mudar de função a qualquer momento: canto inferior esquerdo, conta → Função.',
    listOr: '{list} ou {last}',
  },
  common: {
    // Every DateField's calendar and typing hint (issue 823; People's own until then).
    datePicker: {
      open: 'Abrir o calendário',
      previousMonth: 'Mês anterior',
      nextMonth: 'Mês seguinte',
      month: 'Mês',
      year: 'Ano',
      clear: 'Limpar a data',
      dayToken: 'DD',
      monthToken: 'MM',
      yearToken: 'AAAA',
    },
    deactivate: 'Desativar',
    revoke: 'Revogar',
    remove: 'Remover',
    actions: 'Ações',
    calendar: 'Calendário',
    cancel: 'Cancelar',
    close: 'Fechar',
    confirmTitle: 'Confirmar',
    contactSupport: 'Contactar o suporte',
    copyLink: 'Copiar link',
    edit: 'Editar',
    language: 'Idioma',
    linkCopied: 'Link copiado',
    linkCopyFailed: 'Não foi possível copiar o link',
    moduleListHeading: 'Módulos',
    moduleTeaserAction: 'Adicionar na faturação',
    moduleTeaserHeading: 'Também no lumi',
    moduleTeaserNote: 'O proprietário do workspace, os administradores e os Billing Managers podem adicionar estes módulos.',
    moduleTeaserTag: 'Não incluído no seu plano',
    no: 'Não',
    nothingHere: 'Ainda não há nada aqui',
    ok: 'OK',
    refresh: 'Atualizar',
    retry: 'Tentar novamente',
    role: 'Função',
    save: 'Guardar',
    search: 'Pesquisar',
    switchModule: 'Mudar de módulo',
    tabsNext: 'Mostrar os separadores seguintes',
    tabsPrevious: 'Mostrar os separadores anteriores',
    understood: 'Entendido',
    userDeactivated: '{name} (conta desativada)',
    yes: 'Sim',
  },
  errors: {
    // ADR 0036 code-first branch (errorKeyFor): a backend `code` wins over the
    // status. `invalid_credentials` is what every login door answers a bad
    // sign-in with — a bare 401 would otherwise fall through to
    // `errors.unauthorized`, telling someone who mistyped their password that
    // their session expired (issue 364, F10). It never lets a caller tell an
    // unknown account apart from a mistyped password — the two answer
    // identically — so the copy names both fields.
    // `MASTER_INVITE_REJECTED` is people-api's fallback when the identity
    // service refuses an invitation payload without a code of its own (issue
    // 364, decisions round 1): without an entry here it degrades to the
    // status-derived message, which says nothing about what to look at. Its
    // sibling `MASTER_TENANT_NOT_FOUND` stays local to PersonDetailView on
    // purpose — that one names a next step specific to that screen.
    codes: {
      invalid_credentials: 'Falha ao iniciar sessão. Verifique o seu endereço de e-mail e a sua palavra-passe.',
      MASTER_INVITE_REJECTED: 'Este convite foi recusado porque não foi possível aceitar os dados da pessoa. Verifique o endereço de e-mail e o nome no registo da pessoa e tente novamente.',
      PERSON_EMAIL_INVALID: 'Esta pessoa não tem um endereço de e-mail válido, pelo que não é possível convidar um início de sessão. Corrija primeiro o endereço no registo da pessoa.',
      PERSON_PHONE_INVALID: 'Este número de telemóvel não é válido. Introduza-o em formato internacional, com + e o indicativo do país, p. ex. +351 912 345 678.',
      PERSON_ACCESS_PHONE_TAKEN: 'Outra pessoa já tem um acesso com este número de telemóvel, ou está a recebê-lo. Um número, uma pessoa.',
      PHONE_ACCESS_UNAVAILABLE: 'O acesso por número de telemóvel não está disponível aqui — para este espaço de trabalho ou para o país deste número. Use antes um endereço de e-mail.',
      SUITE_ROLE_NEEDS_EMAIL: 'Esta pessoa inicia sessão com um número de telemóvel e não tem endereço de e-mail. As funções da suite recebem mensagens jurídicas, de faturação e de consentimento, por isso precisam de um endereço.',
      OWNER_NEEDS_EMAIL: 'Esta pessoa inicia sessão com um número de telemóvel e não tem endereço de e-mail. O proprietário recebe mensagens jurídicas e contratuais, por isso a propriedade precisa de um endereço.',
      RECORD_CHANGED: 'Outra pessoa alterou este registo enquanto o estava a editar. Recarregue-o – os seus dados ficam guardados como rascunho.',
    },
    appUpdatedBody: 'Esta página não foi totalmente carregada porque a aplicação foi atualizada. Recarregar para continuar.',
    appUpdatedTitle: 'Está disponível uma nova versão',
    conflict: 'Esta ação está em conflito com o estado atual. Recarregar e tentar novamente.',
    contactSupport: 'Contactar o suporte',
    exhausted: 'Isto parece mesmo estar com problemas. Lamentamos. Contactar o suporte.',
    failedTitle: 'Falha na ação',
    forbidden: 'Sem autorização para esta ação.',
    loadFailedTitle: 'Não foi possível carregar',
    network: 'Sem ligação ao servidor. Verificar a ligação à Internet.',
    notFound: 'O item solicitado não foi encontrado.',
    rateLimited: 'Demasiados pedidos. Aguardar um momento e tentar novamente.',
    recordChangedReload: 'Outra pessoa guardou este registo depois de o ter aberto, por isso a sua alteração não foi aplicada. Recarregue para ver a versão atual – os seus dados ficam guardados e podem ser restaurados.',
    refreshFailedTitle: 'Estes dados podem estar desatualizados',
    server: 'Ocorreu um erro no servidor. Tentar novamente mais tarde.',
    timeout: 'O servidor não respondeu a tempo. Tentar novamente dentro de momentos.',
    unauthorized: 'A sessão expirou. Iniciar sessão novamente.',
    unexpected: 'Ocorreu um erro ao mostrar isto. Tentar novamente.',
    validation: 'Verificar os dados introduzidos.',
  },
  notReady: {
    title: 'Isto ainda não está pronto para si',
    body: 'O seu espaço de trabalho ainda está a ser preparado. Iremos levá-lo de volta ao workspace dentro de 5 segundos.',
  },
  // The workspace this app was opened on does not exist, or can no longer be
  // reached (issue 364, F57). ONE message for BOTH causes on purpose: ats-api
  // answers a suspended tenant and an unknown slug identically, and splitting
  // the copy would confirm which workspaces exist. `body` therefore names no
  // cause, and nothing on the page names a workspace, a slug or a person.
  tenantUnavailable: {
    title: 'Este espaço de trabalho não está disponível',
    body: 'Este espaço de trabalho não existe ou não está acessível neste momento — convém verificar o endereço aberto.',
    accountLead: 'Os dados pessoais e as faturas continuam disponíveis na conta lumi.',
    accountCta: 'Ir para a conta lumi',
    supportLead: 'Se isto for um engano, basta entrar em contacto e resolvemos em conjunto.',
    // The signed-in person's own membership is gone (issue 669): a revoked demo guest,
    // or a demo that ended under an open tab.
    ended: {
      title: 'Sem acesso a este espaço de trabalho',
      body: 'A sessão está iniciada, mas esta conta não é (ou já não é) membro deste espaço de trabalho. Em caso de convite para uma demonstração, a demonstração terminou ou o convite foi retirado.',
      accountLead: 'A conta lumi em si não é afetada.',
    },
  },
  billing: {
    banner: {
      suspendedTitle: 'Espaço bloqueado',
      suspendedMessage: 'Este espaço de trabalho está suspenso. Contacte-nos para restabelecer o acesso.',
      lockedBody: 'Este espaço de trabalho foi bloqueado devido a um problema de faturação pendente. O acesso a todos os módulos está suspenso de momento.',
      lockedSupportLead: 'Para restabelecer o acesso, contacte a nossa equipa de apoio:',
      lockedSupportCta: 'Contactar o apoio',
      lockoutOn: 'Caso contrário, será bloqueado a {date}.',
      fixCardTitle: 'Atualize o cartão',
      fixCardBody: 'O último pagamento foi recusado porque o cartão não foi aceite.',
      fixCardCta: 'Atualizar cartão',
      softDeclineTitle: 'Garanta o pagamento',
      softDeclineBody: 'Não foi possível cobrar o último pagamento e vamos tentar novamente automaticamente. Confirme que o método de pagamento tem saldo suficiente.',
      softDeclineCta: 'Rever método de pagamento',
      scaTitle: 'Confirme o pagamento',
      scaBody: 'O banco precisa que confirme este pagamento antes de o podermos cobrar.',
      scaCta: 'Confirmar pagamento',
      recoveryError: 'Não foi possível iniciar o pagamento neste momento. Tente novamente dentro de instantes.',
      chargebackTitle: 'Regularize o pagamento revertido',
      chargebackBody: 'O banco reverteu um pagamento, pelo que voltou a estar pendente. Adicione um método de pagamento para o regularizar.',
      chargebackCta: 'Adicionar método de pagamento',
      trialTitle: 'Adicione um método de pagamento',
      trialBody: 'O período de teste terminou. Adicione um método de pagamento para manter este espaço de trabalho ativo.',
      trialCta: 'Adicionar método de pagamento',
      reviewTitle: 'Reveja a faturação',
      reviewBody: 'Este espaço de trabalho precisa de uma ação de faturação para se manter ativo.',
      reviewCta: 'Gerir faturação',
      contactTitle: 'Contacte o administrador',
      contactBody: 'Um problema de faturação precisa de atenção para manter este espaço de trabalho ativo.',
    },
  },
  legalNoticeBanner: {
    title: 'Os avisos legais precisam de atenção',
    employeeBody: 'Os convites estão em pausa até o aviso de privacidade para colaboradores estar completo.',
    candidateBody: 'O portal de carreiras está offline até os avisos para candidatos estarem completos.',
    imprintBody: 'O portal de carreiras está offline até a informação legal estar guardada.',
    candidateImprintBody: 'O portal de carreiras está offline até os avisos para candidatos estarem completos e a informação legal estar guardada.',
    cta: 'Abrir Avisos legais',
  },
  // The one "needs you" strip (issue 713): the list label, the hide control and the
  // per-item sentences. A lone legal item reuses legalNoticeBanner.* word for word.
  needsYou: {
    label: 'Ainda precisa de si:',
    hide: 'Ocultar',
    timeRules: {
      link: 'Regras de tempo de trabalho',
      cta: 'Verificar',
      body: 'As regras de tempo de trabalho ainda não foram verificadas. O lumi calcula com as regras legais predefinidas e apenas avisa até alguém confirmar que se adequam à empresa.',
    },
    legal: { link: 'Preencher os avisos legais' },
    billing: {
      link: 'Concluir a faturação',
      cta: 'Abrir a faturação',
      bodyBoth: 'Adicione os dados de faturação e um método de pagamento para que o espaço de trabalho continue a funcionar sem interrupções.',
      bodyInvoiceDetails: 'Adicione os dados de faturação para que as faturas sejam emitidas corretamente.',
      bodyPaymentMethod: 'Adicione um método de pagamento para que o espaço de trabalho continue a funcionar sem interrupções.',
    },
  },
  // Consented temporary support access (ADR 0041): the marker every module
  // chrome shows beside the tenant name while a supporter is inside a grant.
  supportAccess: {
    label: 'Acesso de suporte',
    until: 'Acesso de suporte temporário até {until} — tudo o que fizer aqui fica registado no registo de auditoria deste tenant.',
  },
  // Idle session timeout (issue 265). Owned by app-kit's IdleLogoutGuard, except
  // idleSignedOut — the login pages (workspace, system-admin) render that after
  // the bounce, and it is the same suite-wide policy statement, so it stays in one
  // place rather than drifting between the two login surfaces.
  session: {
    idleTitle: 'Ainda aí?',
    idleBody: 'Está inativo há algum tempo. Para sua segurança, vamos terminar a sessão automaticamente.',
    idleStay: 'Manter sessão iniciada',
    idleSignedOut: 'A sua sessão terminou após {minutes} minutos de inatividade. Inicie sessão novamente.',
  },
  // Browser form drafts (owner-stamped, 7 days, typed values only — app-kit
  // utils/formDraftStorage.ts). Owned by app-kit's DraftBanner and by the
  // sign-out warning every module chrome shows, so the wording lives here instead
  // of drifting across five app catalogs.
  formDrafts: {
    bannerTitle: 'Rascunho não guardado',
    bannerSavedAt: 'Guardado neste dispositivo: {when}',
    bannerRecordChanged: 'O registo foi alterado desde este rascunho. Restaurar repõe apenas os campos que alterou.',
    restore: 'Restaurar',
    discard: 'Descartar',
    closeTitle: 'Descartar os dados introduzidos em «{form}»?',
    closeBody: 'Os dados não guardados serão perdidos.',
    closeConfirm: 'Descartar',
    closeCancel: 'Continuar a editar',
    recordChangedTitle: 'Alterado por outra pessoa',
    reload: 'Recarregar',
    forms: {
      'apprentice': {
        planStation: 'Etapa do plano de formação',
        skillCatalogue: 'Catálogo de competências',
        trainingData: 'Dados da formação',
      },
      'ats': {
        workflowEditor: 'Editor de fluxo de trabalho',
      },
      'backoffice': {
        applicationForm: 'Candidatura',
        createApplication: 'Nova candidatura',
        customField: 'Campo personalizado',
        customFields: 'Campos personalizados',
        emailSettings: 'Definições de email',
        jobAd: 'Anúncio de emprego',
        jobAdTemplate: 'Modelo de anúncio de emprego',
        jobEdit: 'Vaga',
        portalSettings: 'Definições do portal de carreiras',
        ravenBatchPublish: 'Publicação em lote de vagas',
        ravenPublish: 'Publicação de vaga',
        role: 'Função',
        suggestion: 'Sugestão',
        supportTicket: 'Pedido de suporte',
        supportTicketReply: 'Resposta ao pedido de suporte',
        talentEdit: 'Perfil do talento',
        workflowAction: 'Ação de fluxo de trabalho',
        workflowCondition: 'Condição de fluxo de trabalho',
        workflowGuard: 'Guarda de fluxo de trabalho',
        workflowState: 'Estado de fluxo de trabalho',
        workflowTransition: 'Transição de fluxo de trabalho',
      },
      'people': {
        bankAccount: 'Conta bancária',
        companyProfile: 'Perfil da empresa',
        employmentContract: 'Contrato de trabalho',
        myProfile: 'O meu perfil',
        onboardingTemplate: 'Modelo de onboarding',
        oneTimePayment: 'Pagamento único',
        orgUnit: 'Unidade organizacional',
        person: 'Pessoa',
        taxProfile: 'Perfil fiscal',
        wageAssignment: 'Penhora de salário',
      },
      'system-admin': {
        fileQuota: 'Quota de ficheiros',
        skillDetail: 'Detalhe da competência',
        suggestionNotes: 'Notas da sugestão',
      },
      'time': {
        blueprint: 'Modelo de horário de trabalho',
        leaveRequest: 'Pedido de ausência',
        leaveType: 'Tipo de ausência',
        orgGroup: 'Grupo organizacional',
        project: 'Projeto',
        role: 'Função',
        userProfile: 'Perfil de utilizador',
        weekGrid: 'Grelha semanal',
        workTimeModel: 'Modelo de horário de trabalho',
      },
      'user': {
        ssoSettings: 'Definições de SSO',
      },
      'workspace': {
        billingProfile: 'Perfil de faturação',
        wizardGeneral: 'Assistente de configuração',
      },
    },
  },
  // Suite-wide legal footer (issue 221): the § 5 DDG imprint and the privacy
  // notice of the Lumi entity live once on the marketing site, and every app
  // links to them through the shared LegalLinksFooter. The wording is
  // byte-identical everywhere, so it belongs to app-kit rather than to any app.
  legal: {
    imprint: 'Informação legal',
    privacy: 'Privacidade',
    terms: 'Termos',
    label: 'Informações legais',
    employeeNotice: 'Privacidade em {company}',
  },
  dataImport: {
    run: {
      stepsLabel: 'Passos da importação',
      steps: {
        file: 'Ficheiro',
        questions: 'Perguntas',
        review: 'Verificar',
        commit: 'Confirmar',
      },
      toOverview: 'Voltar à visão geral',
      reading: 'A ler {file}',
      checking: 'A verificar as linhas',
      committing: 'A importar os dados',
      tables: '{count} tabela | {count} tabelas',
      rows: '{count} linha | {count} linhas',
      aiOn: 'A Lumi melhora o mapeamento',
      aiOff: 'Mapeamento por regras',
      proposalByRules: 'Proposta por regras · {reason}',
      reasons: {
        off: 'A Lumi estava desligada para este ficheiro.',
        disabled: 'A IA está desligada neste espaço de trabalho.',
        quota: 'A quota de IA estava esgotada.',
        no_key: 'Não há nenhuma chave de IA configurada.',
        error: 'A Lumi não estava acessível neste momento.',
      },
    },
    title: 'Importação de dados',
    intro: 'Importe dados existentes de um sistema antigo: envie um arquivo, revise o mapeamento de campos, examine a simulação e só então confirme.',
    backToList: 'Voltar à visão geral',
    sourceSystem: 'Sistema de origem',
    cancelled: 'Esta importação foi cancelada.',
    steps: {
      upload: 'Envio',
      analysis: 'Análise',
      mapping: 'Mapeamento',
      dryRun: 'Simulação',
      commit: 'Confirmação',
    },
    status: {
      uploaded: 'Enviado',
      analyzing: 'Analisando',
      mapping_ready: 'Revisar mapeamento',
      dry_running: 'Simulação em andamento',
      dry_run_ready: 'Simulação pronta',
      committing: 'Confirmando',
      completed: 'Concluído',
      failed: 'Falhou',
      cancelled: 'Cancelado',
    },
    formats: {
      csv: 'CSV',
      xlsx: 'Excel',
      json: 'JSON',
      sql_dump: 'Dump SQL',
      hropen: 'HR Open JSON',
    },
    transforms: {
      none: 'Direto',
      date: 'Data',
      number: 'Número',
      boolean: 'Sim/Não',
      enum_map: 'Mapeamento de valores',
      split_name: 'Dividir nome',
      concat: 'Concatenar',
      const: 'Constante',
      skip: 'Ignorar',
    },
    upload: {
      sourceSystem: 'Nome do sistema de origem',
      sourceSystemHint: 'Guardado como referência para que reimportar o mesmo arquivo atualize registros em vez de duplicá-los.',
      sourceSystemPlaceholder: 'ex.: rh_antigo',
      sourceSystemFirst: 'Informe primeiro o sistema de origem.',
      dropHint: 'Arraste um arquivo para cá ou procure',
      formats: 'CSV, Excel (XLSX), JSON ou dump SQL — máx. 50 MB',
      browse: 'Escolher arquivo',
      uploading: 'Enviando …',
    },
    running: {
      uploaded: 'Iniciando análise …',
      analyzing: 'Analisando arquivo …',
      dry_running: 'Simulação em andamento …',
      committing: 'Gravando dados …',
      hint: 'Arquivos grandes podem levar alguns minutos. Esta página é atualizada automaticamente.',
    },
    failed: {
      title: 'A importação falhou',
      generic: 'Não foi possível ler o ficheiro.',
      unsupported: 'Este formato de ficheiro não é suportado. Use-se CSV, Excel, JSON, um dump SQL ou HR Open.',
      empty: 'O ficheiro não contém nenhuma linha.',
      enqueue: 'Não foi possível iniciar a importação. Convém tentar de novo daqui a pouco.',
      dryRun: 'Não foi possível verificar as linhas. O ficheiro deve ser reiniciado a partir da vista geral.',
      commit: 'Não foi possível adotar os dados. O ficheiro deve ser reiniciado a partir da vista geral.',
    },
    questions: {
      quoted: '«{value}»',
      saving: 'A atribuição está a ser guardada',
      companionRunning: '{entity} estão a ser criados em {module}',
      reading: {
        title: 'O que reconhecemos',
        taken: 'Será importado',
        notTaken: 'Não será importado',
        from: 'da coluna',
        nothingTaken: 'Deste ficheiro ainda nada é importado.',
        split: '(dividido)',
        joined: '(combinado)',
        reasons: {
          other_entry: 'pertence a outra entrada',
          never_importable: 'nunca é importado',
          no_field: 'nenhum campo adequado',
        },
        wrong: 'Algo não está certo?',
        editMapping: 'Alterar a atribuição ao pormenor',
        improve: 'Deixar o Lumi melhorar',
        improveConflict: 'Neste momento não é possível ler o ficheiro de novo. É preciso recarregar a página e tentar outra vez.',
      },
      extras: {
        title: 'O ficheiro contém também outros dados. É para importá-los também?',
        columns: 'De {columns}.',
        companion: 'De {columns}: {count} novo valor, criado em {module} antes do resto dos dados. | De {columns}: {count} novos valores, criados em {module} antes do resto dos dados.',
        companionTruncated: 'De {columns}: pelo menos {count} novo valor, criado em {module} antes do resto dos dados. | De {columns}: pelo menos {count} novos valores, criados em {module} antes do resto dos dados.',
        asOwnEntry: 'O que for importado além disso aparece na migração como uma entrada própria (de {file}).',
        forbidden: 'Falta a permissão em {module} para isto. A importação continua sem estes dados.',
        unavailable: '{module} não respondeu neste momento. A importação continua sem estes dados.',
      },
      list: {
        heading: 'Não há mais nada a perguntar | Há uma coisa a perguntar | Há {count} coisas a perguntar',
      },
      uncertain: {
        title: 'A coluna {column} contém {samples} — é {field}?',
        titleNoSamples: 'A coluna {column} — é {field}?',
        yes: 'Sim, é {field}',
        no: 'Não, é …',
        pickField: 'Escolher um campo',
        skip: 'Não importar',
      },
      required: {
        title: 'Para {entity} é necessário {field}. De onde vem?',
        forAll: 'Igual para todos:',
        pickValue: 'Escolher um valor',
        inColumn: 'Está na coluna …',
        pickColumn: 'Escolher uma coluna',
        none: 'O ficheiro não tem isto',
      },
      supervisor: {
        title: 'Quem é a chefia destas pessoas?',
        fromColumn: 'Da coluna',
        columnHint: 'O número de colaborador tem de constar neste ficheiro ou já existir em Pessoal.',
        onePerson: 'Uma pessoa para todos:',
        pickPerson: 'Escolher uma pessoa',
        noPersons: 'Não é possível escolher uma pessoa para todos: a lista de pessoas não está disponível aqui.',
        self: 'Por agora, cada pessoa é a sua própria chefia',
        selfHint: 'O organigrama é construído depois em Pessoal.',
        deferred: 'Por agora sem responsável',
        deferredHint: 'Ao verificar, assinalamos as linhas sem responsável.',
        personsTruncated: 'As primeiras 500 pessoas por nome; o número de colaborador da pessoa pretendida também pode ser indicado através de uma coluna.',
      },
      enum: {
        title: 'Em {column} há valores que {module} não conhece',
        count: '{count}×',
        pick: 'Escolher',
        leaveEmpty: 'deixar vazio',
        rowLabel: 'Atribuição para {value}',
        viaCompanion: 'é criado em {module}',
      },
      date: {
        title: 'Como está escrita a data em {column}?',
        day: 'dia',
        month: 'mês',
        year: 'ano',
        yearShort: 'ano (2 dígitos)',
        example: '{sample} é lido como {date}',
      },
      fold: {
        title: 'Todas as atribuições ao pormenor ({count} coluna) | Todas as atribuições ao pormenor ({count} colunas)',
        show: 'Mostrar',
        hide: 'Ocultar',
      },
      verdict: {
        title: 'Este ficheiro não pode tornar-se {entry}',
        missing: 'Falta: {fields}. Nenhuma coluna do ficheiro o pode fornecer.',
        extraHint: 'Se os dados adicionais acima forem desmarcados, isto deixa de se aplicar.',
        elsewhere: 'Escolher outra entrada:',
        readAs: 'Ler como {entry}',
        otherModule: 'Se o ficheiro pertence a outro módulo, é de o rejeitar aqui e de o colocar onde pertence.',
        discard: 'Rejeitar ficheiro',
      },
      footer: {
        next: 'A seguir verificamos cada linha. Ainda não se guarda nada.',
        nextCreating: 'Primeiro criamos {count} novo valor ({what}) em {module} e depois verificamos cada linha do ficheiro. | Primeiro criamos {count} novos valores ({what}) em {module} e depois verificamos cada linha do ficheiro.',
        back: 'Voltar',
        confirm: 'Seguinte: verificar os dados',
        confirmCreating: 'Seguinte: criar e verificar',
        open: 'Uma pergunta ainda em aberto | {count} perguntas ainda em aberto',
        withoutThem: 'É possível continuar sem estes dados.',
      },
    },
    mapping: {
      hint: 'Revise o mapeamento proposto: um destino por tabela e um campo por coluna. Linhas destacadas são propostas incertas.',
      targetEntity: 'Destino',
      skipTable: 'Não importar',
      skippedTable: 'Esta tabela não será importada.',
      ignoreColumn: 'Ignorar',
      sourceColumn: 'Coluna',
      sample: 'Valores de exemplo',
      targetField: 'Campo de destino',
      transform: 'Transformação',
      preview: 'Pré-visualização',
      rowCount: '{count} linhas',
      patternHint: 'Padrão de data, ex.: DD.MM.YYYY',
      multiTargetHint: 'Destino {index} de {total} — o mesmo ficheiro alimenta vários destinos',
      valueMap: 'Atribuir valores',
      valueMapHint: 'Atribua os valores de origem aos valores permitidos no sistema. Valores não atribuídos produzem um erro por linha no ensaio. Baseado em até 20 valores de exemplo distintos da coluna.',
      valueMapUnmapped: '— não atribuído —',
      addColumnRow: 'Atribuir uma coluna novamente',
      customFieldBadge: 'Campo personalizado',
      createCustomField: 'Criar novo campo personalizado…',
      confirm: 'Confirmar mapeamento e iniciar simulação',
    },
    report: {
      dryRunHint: 'Simulação — nada foi gravado ainda. Verifique os totais e erros antes de confirmar.',
      completedHint: 'Importação concluída. Os dados foram gravados.',
      created: 'Criados',
      updated: 'Atualizados',
      skipped: 'Ignorados',
      errors: 'Erros',
      errorList: '{count} erros',
      downloadErrors: 'Baixar todos os erros',
      row: 'Linha',
      errorMessage: 'Mensagem',
      backToMapping: 'Voltar ao mapeamento',
      commit: 'Confirmar dados',
      commitConfirmTitle: 'Confirmar dados?',
      commitConfirmBody: 'A importação gravará agora neste módulo. Novos registros são criados, os existentes atualizados. Não é possível desfazer automaticamente.',
      commitStarted: 'Confirmação iniciada – os dados estão a ser gravados.',
    },
    review: {
      title: 'Isto é o que entra no sistema. Há algo a alterar?',
      filterLabel: 'Filtrar linhas',
      note: 'As alterações valem apenas para esta importação. O ficheiro permanece como está.',
      row: 'Linha',
      status: 'Estado',
      choose: 'Escolher …',
      yes: 'Sim',
      no: 'Não',
      noRows: 'Nenhuma linha para esta seleção.',
      rowsNoun: 'Linhas',
      tiles: {
        new: 'Novo',
        updated: 'Atualizado',
        toClear: 'Por esclarecer',
        newNote: 'A criar: {things}',
        updatedNote: 'já existem, os campos em falta são preenchidos',
        toClearNote: 'caso contrário ficam de fora',
      },
      leftOut: '{count} linha excluída | {count} linhas excluídas',
      filter: {
        all: 'Todas',
        skipped: 'Excluídas',
      },
      statuses: {
        new: 'novo',
        updated: 'atualizado',
        open: 'em aberto',
        corrected: 'corrigido',
        skipped: 'excluído',
      },
      fixField: 'Corrigir {field} na linha {row}',
      reasonOf: 'Porque a linha {row} está em aberto',
      popoverLabel: 'Linha {row}: o que está errado',
      mean: 'Seria {value}?',
      accept: 'Usar {value}',
      findPerson: 'Procurar uma pessoa …',
      pickPerson: 'Escolher uma pessoa',
      setForAll: 'Aplicar às {count} iguais',
      skipRow: 'Excluir esta linha',
      leaveEmpty: 'Deixar o campo vazio nesta linha',
      undo: 'Anular',
      reason: {
        required: 'Falta {field}',
        missing: 'Falta um valor obrigatório',
        invalid: 'O valor não é válido',
        notFound: '{ref} não encontrado',
        notFoundAny: 'Referência não encontrada',
        ambiguous: 'Referência pouco clara',
        emailLinked: 'Este e-mail pertence a um acesso',
        general: 'Linha não importada',
        skipped: 'Linha excluída',
      },
      changes: '{count} alteração registada | {count} alterações registadas',
      openRows: '{count} linha ainda por esclarecer | {count} linhas ainda por esclarecer',
      footer: {
        unchecked: '{changes} · {open}. Primeiro verificar de novo, depois importar.',
        withdrawn: 'Todas as alterações foram anuladas. Primeiro verificar de novo, depois importar.',
        checked: '{open}. Também é possível importar já; esta linha fica então de fora. | {open}. Também é possível importar já; estas {count} ficam então de fora.',
        clear: 'Tudo esclarecido.',
      },
      back: 'Voltar às perguntas',
      recheck: 'Verificar de novo',
      commit: 'Importar {count} {things}',
      truncated: {
        all: 'A mostrar {shown} de {total} linhas; estão incluídas todas as {open} por esclarecer.',
        some: 'A mostrar {shown} de {open} linhas por esclarecer — as restantes estão no ficheiro de erros.',
      },
      notice: {
        movedOn: 'Entretanto a importação avançou. A página mostra agora o ponto em que está.',
        cell: 'Esta célula não pode ser alterada aqui.',
        value: 'O valor não é válido.',
        generic: 'Não foi possível guardar a alteração.',
        notChecked: 'Há alterações que a verificação ainda não viu. Verificar de novo e depois importar.',
      },
      commitConfirmOpen: '{count} linha fica de fora e será listada depois. | {count} linhas ficam de fora e serão listadas depois.',
    },
    // An import report's error row, worded from the facts the module sent (rowErrorText.ts).
    rowErrors: {
      required: '{field} está vazio, mas cada linha precisa de um valor.',
      unknownField: 'Não é possível importar {field} aqui.',
      invalidEnum: '«{value}» não é um valor válido para {field}. Valores válidos: {allowed}.',
      // With the review\'s handles: the cell holds the way out.
      invalidEnumCell: '«{value}» não é um valor válido para {field}. Valores válidos: {allowed}. É necessário escolher na célula um valor permitido.',
      unresolved: {
        person: 'Nenhuma pessoa encontrada com {keys} «{value}».',
        supervisor: 'Nenhum responsável hierárquico encontrado com {keys} «{value}».',
        functionalSupervisor: 'Nenhum responsável funcional encontrado com {keys} «{value}».',
        orgUnit: 'Nenhuma unidade org. encontrada com {keys} «{value}».',
        parentOrgUnit: 'Nenhuma unidade org. superior encontrada com {keys} «{value}».',
      },
      supervisorRequired: 'Nenhum responsável hierárquico encontrado com {keys} «{value}», e esta pessoa ainda não tem nenhum. Cada pessoa ativa precisa de um: é necessário importar primeiro o responsável hierárquico ou indicar um que já exista.',
      unknownEntity: 'Este tipo de dados não pode ser importado aqui.',
      emailLinked: 'Esta pessoa inicia sessão no lumi com este endereço de e-mail, por isso a importação não o altera. O endereço mantém-se como está no acesso — é possível deixar o campo vazio nesta linha para importar o resto.',
      supervisorMissing: 'Cada pessoa ativa precisa de um responsável hierárquico e esta pessoa não tem nenhum. É necessário indicar um no ficheiro ou criar primeiro o responsável.',
      transformFailed: 'Não foi possível converter «{value}» na coluna {field}. É possível verificar o formato em «Transformação» no passo de mapeamento.',
      transformFailedNoValue: 'Não foi possível converter um valor na coluna {field}. É possível verificar o formato em «Transformação» no passo de mapeamento.',
      unknown: 'Esta linha não foi importada. Os detalhes estão no ficheiro de erros.',
      skippedByUser: 'Esta linha foi excluída, por isso não é importada.',
      requiredAny: 'Nesta linha falta um valor obrigatório.',
      invalidEnumAny: 'Um valor desta linha não é um dos valores permitidos.',
      unknownFieldAny: 'Um campo desta linha não pode ser importado aqui.',
      unresolvedAny: 'Não foi encontrado aquilo a que esta linha se refere. Criar primeiro ou excluir a linha.',
      unresolvedLocal: '{thing}: «{value}» não foi encontrado. Criar primeiro a entrada ou excluir a linha.',
      unresolvedUser: 'Nenhuma pessoa deste espaço corresponde a esta linha.',
      invalidTime: 'As horas desta linha não são compatíveis entre si.',
      invalidState: 'O estado desta linha não existe no fluxo publicado.',
      stateChanged: 'O fluxo mudou enquanto esta linha era importada. Verificar de novo.',
      invalidCustomValue: 'O valor de um campo personalizado desta linha não é válido.',
      ambiguous: {
        collision: '{ref}: «{value}» corresponde a dois registos diferentes — a um como ID externo, a outro como {other}. A importação não adivinha: é necessário escolher abaixo o registo correto.',
        otherSystem: '{ref}: «{value}» não é um ID externo deste sistema de origem, mas de «{system}» — e corresponde também a um registo como {other}. A importação não adivinha: é possível importar com o sistema de origem «{system}», se for o mesmo registo, ou escolher abaixo o registo correto.',
        holderHasExternalId: '{ref}: «{value}» só corresponde como {other} — e esse registo já tem o ID externo «{otherId}» neste sistema de origem. A importação não adivinha: é necessário escolher abaixo «{otherId}», se for esse o pretendido.',
      },
      // Without the review's handles (the completed report lists the row; nothing here can be chosen).
      ambiguousPlain: {
        collision: '{ref}: «{value}» corresponde a dois registos diferentes — a um como ID externo, a outro como {other}. A importação não adivinha: é necessário tornar a referência inequívoca no ficheiro.',
        otherSystem: '{ref}: «{value}» não é um ID externo deste sistema de origem, mas de «{system}» — e corresponde também a um registo como {other}. A importação não adivinha: é possível importar com o sistema de origem «{system}», se for o mesmo registo, ou tornar a referência inequívoca.',
        holderHasExternalId: '{ref}: «{value}» só corresponde como {other} — e esse registo já tem o ID externo «{otherId}» neste sistema de origem. A importação não adivinha: é possível referi-lo com «{otherId}», se for esse o pretendido.',
      },
      localRefs: {
        department: 'Departamento',
        location: 'Local',
        candidate: 'Candidato',
        job: 'Vaga',
        client: 'Cliente',
        project: 'Projeto',
        bookingType: 'Tipo de registo',
        leaveType: 'Tipo de ausência',
      },
      refs: {
        person: 'Pessoa',
        supervisor: 'Responsável hierárquico',
        functionalSupervisor: 'Responsável funcional',
        orgUnit: 'Unidade org.',
        parentOrgUnit: 'Unidade org. superior',
      },
      supervisorInactive: {
        supervisor: 'O responsável hierárquico indicado já não está ativo e por isso não pode chefiar ninguém.',
        functional: 'O responsável funcional indicado já não está ativo e por isso não pode chefiar ninguém.',
      },
      supervisorUnconfirmed: {
        supervisor: 'O responsável hierárquico indicado ainda não foi confirmado pelos RH e por isso não pode chefiar ninguém. É necessário confirmá-lo primeiro no People.',
        functional: 'O responsável funcional indicado ainda não foi confirmado pelos RH e por isso não pode chefiar ninguém. É necessário confirmá-lo primeiro no People.',
      },
      datesInverted: 'A data em {end} é anterior à data em {start}.',
      agreementCodeInvalid: '{field} só aceita letras, algarismos, «-», «_» e «.», no máximo 60 caracteres e sem espaços.',
      statusTransition: 'Um contrato não pode passar de «{from}» para «{to}».',
      reportingCycle: 'Esta atribuição fecharia a linha hierárquica num círculo.',
      ambiguousOrgCode: 'Várias unidades org. de tipos diferentes têm o código «{value}». É necessário indicar a correta pelo seu ID externo.',
      keys: {
        externalId: 'ID externo',
        employeeNumber: 'número de colaborador',
        code: 'código',
      },
    },
    list: {
      title: 'Importações anteriores',
      file: 'Arquivo',
      system: 'Sistema de origem',
      status: 'Status',
      created: 'Criado',
      empty: 'Ainda não há importações.',
      open: 'Abrir',
      delete: 'Eliminar',
      deleteConfirmTitle: 'Eliminar a importação?',
      deleteConfirmBody: '“{file}” e todos os ficheiros de importação associados serão removidos. Os dados já assumidos mantêm-se.',
      deleted: 'Importação “{file}” eliminada.',
    },
  },
  dataExport: {
    title: 'Exportação HR Open',
    intro: 'Exporta os dados deste módulo como HR Open 4.5 (HR-JSON) — validado contra o padrão.',
    create: 'Criar exportação',
    creating: 'Criando …',
    download: 'Baixar',
    password: {
      title: 'Palavra-passe do ZIP — visível só agora',
      hint: 'A exportação é criada como ZIP protegido por palavra-passe (AES-256) porque contém dados pessoais. Copie a palavra-passe agora — não voltará a ser mostrada. Abrir com p. ex. 7-Zip, WinZip ou Keka.',
      copy: 'Copiar palavra-passe',
      copied: 'Copiada',
    },
    empty: 'Ainda não há exportações.',
    columns: {
      standard: 'Padrão',
      status: 'Status',
      items: 'Registros',
      created: 'Criado',
    },
    status: {
      queued: 'Na fila',
      generating: 'Gerando',
      completed: 'Concluído',
      failed: 'Falhou',
    },
  },
  // The demo's module picker (ADR 0083): the fork offers it on entry, the bar's
  // reset confirmation again. A locked module is booked (or core) and always in.
  // RoleNameTranslations.vue (ADR 0086): a custom role's names in other
  // languages, or the notice a system role gets instead.
  roleNames: {
    translations: 'Traduções',
    translationsHint: 'O nome noutras línguas. Os campos vazios mostram o nome acima.',
    systemHint: 'Função de sistema: a lumi dá-lhe nome em todas as línguas. O nome e a descrição não podem ser alterados; as permissões sim.',
  },
  demoModules: {
    legend: 'Módulos na demonstração',
    booked: 'Contratado — sempre incluído',
  },
  demoStage: {
    label: 'Demo',
    viewingAs: 'Ver como',
    personaPlaceholder: 'Escolher um papel',
    persona: {
      team_lead: 'Chefe de equipa',
      employee: 'Colaborador',
      hr_admin: 'Admin de RH',
      recruiter: 'Recrutador',
      ats_admin: 'Administrador do ATS',
      council_member: 'Membro da comissão de trabalhadores',
      apprentice: 'Aprendiz',
      trainer: 'Formador',
    },
    personaDoes: {
      team_lead: 'Decide sobre pedidos de ausência e correção, e avalia candidaturas.',
      employee: 'Regista dias de trabalho, pede ausências e faz corrigir registos.',
      hr_admin: 'Cria pessoas, projetos e vagas.',
      recruiter: 'Faz avançar candidaturas na triagem inicial e agenda entrevistas.',
      ats_admin: 'Decide sobre ausências, avalia candidaturas e cria vagas.',
      council_member: 'Emite o voto da comissão de trabalhadores sobre vagas e propostas.',
      apprentice: 'Assinala etapas do plano de formação e regista dias de trabalho.',
      trainer: 'Revê relatórios de aprendizes e agenda os respetivos exames.',
    },
    picker: {
      title: 'A partir de que ponto de vista deve ser vista a demonstração?',
      subtitle: '{count} colegas em {company}. Cada papel tem as suas próprias tarefas — as marcações são guardadas por papel.',
      taskCount: '{total} tarefa | {total} tarefas',
      current: 'Vista atual',
    },
    intro: {
      lead: 'é fictícia. As pessoas nela também são fictícias. Tudo o que está abaixo da barra pertence à demonstração — nela são assumidos diferentes papéis. A conta real não é afetada.',
      bridgeBefore: 'A demonstração pode ser terminada a qualquer momento. Todos os dados abaixo são então removidos e é possível configurar ',
      bridgeAfter: ' para a própria organização.',
      close: 'Fechar',
    },
    reset: 'Repor a demonstração',
    guestMarker: 'Convidado',
    guestWelcome: {
      invitedBy: 'Esta demonstração é um convite de um colega de {workspace}.',
      invitedAnon: 'Esta demonstração é um convite de um colega.',
      body: '{company} é fictícia e partilhada com todas as outras pessoas nesta demonstração. Outros podem já ter experimentado coisas, por isso pode parecer meio usada. «{reset}» dá a todos um novo começo. O acesso termina quando a demonstração termina. As pessoas nela também são fictícias.',
    },
    cancel: 'Cancelar',
    rebuildFailed: 'Não foi possível reconstruir a demonstração. É possível tentar novamente.',
    resetConfirm: {
      title: 'Repor a demonstração?',
      body: 'Tudo o que a {company} contém neste momento é descartado — incluindo tudo o que foi introduzido, e o progresso de todos nos percursos — e a demonstração é reconstruída de raiz. Todos na demonstração recomeçam do zero; os acessos não mudam.',
      cta: 'Repor a demonstração',
    },
    // The demo bar's "Invite a colleague" dialog (issue 669).
    guests: {
      entry: 'Convidar um colega',
      title: 'Convidar um colega',
      subtitle: 'Os colegas convidados veem esta demonstração tal como está e podem experimentá-la por conta própria.',
      close: 'Fechar',
      loading: 'A carregar…',
      retry: 'Tentar novamente',
      emailLabel: 'E-mail profissional',
      emailPlaceholder: "nome{'@'}empresa.pt",
      send: 'Enviar convite',
      sendAgain: 'Enviar novamente',
      slotsLeft: '{count} lugar livre | {count} lugares livres',
      exhausted: 'Os {limit} lugares estão ocupados. Para convidar outra pessoa, é preciso revogar um convite abaixo.',
      invalid: 'É preciso um endereço de e-mail válido.',
      listTitle: 'Também nesta demonstração',
      used: '{used} de {limit} ocupados',
      empty: 'Ainda ninguém foi convidado.',
      state: {
        invited: 'Convidado',
        joined: 'Aderiu',
      },
      revoke: 'Revogar',
      revoking: 'A revogar…',
      revokeFor: 'Revogar o acesso de {email}',
      about: {
        title: 'O que é um convidado',
        sees: 'Um convidado vê esta demonstração exatamente como está neste momento — incluindo tudo o que já experimentou. «{reset}» na barra dá a todos um novo começo.',
        resets: 'Um convidado também pode repor a demonstração — para todos os que nela participam.',
        limits: 'Um convidado nunca pode terminar a demonstração nem alterar o espaço de trabalho real.',
        ends: 'Os convidados são removidos quando a demonstração termina.',
      },
      feedback: {
        sent: 'Convite enviado para {email}.',
        resent: 'Convite enviado novamente para {email}.',
        undelivered: 'Não foi possível entregar o e-mail a {email}. {email} está na lista e ocupa um lugar — enviar o convite novamente permite tentar de novo.',
        revoked: 'O acesso de {email} foi revogado. O lugar voltou a ficar livre.',
        alreadyMember: '{email} já tem acesso a este workspace.',
        limit: 'Todos os lugares estão ocupados. Para convidar outra pessoa, é preciso revogar um convite.',
        rateLimited: 'Demasiados convites hoje. É possível tentar novamente mais tarde.',
        notLive: 'Os convites só funcionam enquanto a demonstração está ativa. Está a ser reconstruída ou a configuração começou — é possível tentar novamente quando a demonstração voltar.',
        operator: 'A sessão está iniciada como operador do sistema. Os operadores não podem convidar colegas para a demonstração de um cliente.',
        operatorNotMember: '{email} pertence a uma conta de operador lumi, que não pode entrar na demonstração de um cliente. É preciso convidar outro endereço.',
        notAPerson: '{email} pertence a uma conta que não é uma pessoa, por exemplo uma conta de serviço. É preciso convidar o e-mail de trabalho de um colega.',
        forbidden: 'Só o proprietário do workspace ou um administrador da suite pode convidar colegas.',
        noticeIncomplete: 'Os convites estão em pausa até que os avisos para colaboradores em Avisos legais estejam totalmente preenchidos.',
        accountClosed: 'Essa conta foi encerrada e não pode ser convidada.',
        unavailable: 'Neste momento não é possível contar os convites. É possível tentar novamente daqui a pouco.',
        revokeFailed: 'Não foi possível revogar o acesso de {email}. É possível tentar novamente.',
        generic: 'Algo correu mal. É possível tentar novamente.',
      },
    },
    leave: 'Terminar a demo',
    continueSetup: 'Continuar a configuração',
    menu: 'Ações da demo',
    signOut: 'Terminar sessão',
    logoutHint: 'Durante a demo, a sessão termina-se a partir da porta ou do menu na barra da demo.',
    journey: {
      title: 'O percurso de {name}',
      count: '{done} de {total} concluídas',
      refresh: 'Atualizar o percurso',
      unknown: 'Algumas verificações não estavam acessíveis – é mostrado o último estado conhecido.',
      yay: 'Foi todo o percurso de {name} – bom trabalho.',
      bridgeAdmin: 'Todos os percursos foram percorridos. Quando for altura, terminar a demo e configurar o próprio espaço de trabalho.',
      bridgeUser: 'Todos os percursos foram percorridos. Um administrador pode terminar a demo e configurar o espaço de trabalho.',
      blockedReset: 'Uma reposição recupera-o:',
      blocked: {
        gone: 'O que esta tarefa precisa já não existe.',
      },
      next: 'A seguir',
      nextCta: 'Abrir em {module}',
      footer: 'A demonstração assinala o que já foi feito.',
    },
  },
  // The shared notifications popover (NotificationsPopover.vue). Its own namespace: the
  // apps' `notifications.*` keys (inbox page, preferences) are theirs and stay put.
  notificationsPopover: {
    title: 'Notificações',
    empty: 'Está tudo em dia.',
    markAllRead: 'Marcar todas como lidas',
    markRead: 'Marcar como lida',
    markUnread: 'Marcar como não lida',
    loading: 'A carregar…',
    openTarget: 'Abrir o item associado',
    goToAll: 'Ir para as notificações',
  },
  // The shared place search (PlacePicker.vue). `noMatchAdd` is the wording for hosts whose
  // typed text IS the name (Enter adds it as typed); `noMatch` for hosts that keep it beside the field.
  placePicker: {
    placeholder: 'Procurar uma cidade ou município …',
    keptHint: 'Guardado exatamente como foi escrito — sem localidade associada.',
    searching: 'A procurar …',
    typeMore: 'Escrever pelo menos {count} caracteres',
    noMatch: 'Sem correspondência — o texto escrito mantém-se',
    error: 'A pesquisa falhou',
    rateLimited: 'Demasiadas pesquisas — nova tentativa dentro de momentos',
    resultsAnnouncement: 'Sem resultados | 1 resultado | {count} resultados',
    clear: 'Remover localidade',
    noMatchAdd: 'Nenhuma cidade encontrada — Enter adiciona o nome tal como escrito',
  },
  // The suite's five app names and their one-line launcher descriptions, in this
  // language. THE one copy: component-lib's registry carries no displayed string, and
  // every app merges this underneath its own messages (ADR 0026 section 7).
  lumiModules: {
    suite: {
      name: 'Início',
      description: 'Panorama do local de trabalho',
    },
    ats: {
      name: 'Recrutamento',
      description: 'Vagas, candidaturas e processo de recrutamento',
    },
    time: {
      name: 'Tempo',
      description: 'Registo de tempo, contas de horas de trabalho e aprovações',
    },
    people: {
      name: 'Pessoal',
      description: 'Processos individuais, departamentos e locais',
    },
    apprentice: {
      name: 'Formandos',
      description: 'Cadernos de formação digitais e planos de formação',
    },
  },
};
